<template>
  <b-form @submit="onSubmit">
    <b-card no-body class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b>{{ parceiro.nome }}</b>
          <div class="d-flex flex-row-reverse">
            <b-button type="submit" variant="exitos">Salvar</b-button>

            <router-link
              :to="$routeBack('parceiros_list')"
              class="btn btn-outline-muted mr-2"
              >Voltar para Listagem</router-link
            >
          </div>
        </div>
      </template>

      <b-tabs pills card vertical class="edit-menu-sidebar">
        <b-tab active>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.dados_basicos"
            />
            Dados Básicos
          </template>
          <DadosBasicos ref="dados_basicos" />
        </b-tab>

        <b-tab>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.endereco"
            />
            Endereço
          </template>
          <Endereco ref="endereco" />
        </b-tab>

        <b-tab>
          <template #title> Naturezas jurídica </template>
          <NaturezasJuridicas :data="naturezas_juridicas" />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-form>
</template>

<script>
import DadosBasicos from "./Form/DadosBasicos.vue";
import Endereco from "./Form/Endereco.vue";
import NaturezasJuridicas from "./Form/NaturezasJuridicas.vue";

import { mapActions, mapState } from "vuex";

export default {
  components: { DadosBasicos, Endereco, NaturezasJuridicas },
  data: () => ({
    validations: {
      dados_basicos: true,
      endereco: true,
    },
    naturezas_juridicas: [],
  }),
  computed: {
    ...mapState("parceiros", ["parceiro"]),
  },
  methods: {
    ...mapActions("parceiros", ["ActionSave", "getById", "updatePartnerTypes"]),
    async onSubmit(event) {
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          const valuesToSave = [];
          await this.ActionSave(this.parceiro);
          this.$emit("saved", this.parceiro.id);
          this.naturezas_juridicas.map((val) => {
            if (val.marcado === true) {
              valuesToSave.push(val.id);
            }
          });

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });
        } catch (error) {
          let error_message = "Erro ao salvar";
          this.$notifications.addNotification({
            message: error_message,
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
      }
    },
    isValid() {
      this.validations.dados_basicos = this.$refs.dados_basicos.isValid();
      return Object.values(this.validations).every(Boolean);
    },
    async fetchParceiroById() {
      try {
        const id = this.parceiro.id ? this.parceiro.id : 0;

        const data = await this.getById(id);
        this.naturezas_juridicas = data;
      } catch (error) {
        console.error("Erro ao buscar o parceiro:", error);
      }
    },
  },
  async created() {
    this.fetchParceiroById();
  },
};
</script>

<style></style>
